import { ca } from '@cian/analytics';
import { IApplicationContext } from '../../common/types/applicationContext';

export function clickBuyerSendForm(context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'сlick',
    category: 'DemandCpd',
    label: 'send',
    page: {
      pageType: 'DemandCpdBuyLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
        cpdDealType: 'buy',
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function clickBuyerOpenModal(label: string, context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'сlick',
    category: 'DemandCpd',
    label,
    page: {
      pageType: 'DemandCpdBuyLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
        cpdDealType: 'buy',
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function successBuyerSendForm(draftId: number, context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Send',
    category: 'DemandCpd',
    label: 'Success',
    page: {
      pageType: 'DemandCpdBuyLandingPage',
      extra: {
        source,
        draft_id: draftId,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
        cpdDealType: 'buy',
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function failedBuyerSendForm(context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Show_sopr',
    category: 'DemandCpd',
    label: 'Fail',
    page: {
      pageType: 'DemandCpdBuyLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
        cpdDealType: 'buy',
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}
